import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import styles from "./LoginPromptBanner.module.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LoginPromptBanner = ({ show, setShow, actionText }) => {
    const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        setShow(false);
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [show, setShow]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className={styles.banner}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10 }}
          transition={{ duration: 0.3 }}
        >
          <button onClick={() => navigate("/login")} className={styles.linkButton}>
            {t("login_button")}
          </button>
          /
          <button onClick={() => navigate("/sign-up")} className={styles.linkButton}>
            {t("sign-up")}
          </button>
          {" "}{t('to_action')} {actionText}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LoginPromptBanner;
